import { render } from "./DataCollector.vue?vue&type=template&id=7bf965c0"
import script from "./DataCollector.vue?vue&type=script&lang=js"
export * from "./DataCollector.vue?vue&type=script&lang=js"

import "./DataCollector.vue?vue&type=style&index=0&id=7bf965c0&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__